// The Admin test script as a CSV: one row per question with the answer, what
// should happen, and (after "Run it") what did happen.

function csvCell(value) {
  const text = String(value ?? "");
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export const TEST_SCRIPT_COLUMNS = [
  "session_id", "question_number", "question", "has_follow_ups", "test_case", "label", "english_level",
  "answer", "expected", "actual", "as_expected", "error_type", "reason", "check_seconds", "note",
];

export function testScriptCsv(script, results) {
  const byNumber = results?.byNumber || {};
  const rows = (script?.questions || []).map((q) => {
    const r = byNumber[q.number];
    return [
      script.session_id, q.number, q.text, q.has_follow_ups ? "yes" : "no", q.case, q.label, q.english || "",
      q.say, q.expect,
      r ? r.actual : "", r ? (r.ok ? "yes" : r.status === "inconclusive" ? "inconclusive" : "NO") : "",
      r?.error_type || "", r?.reason || "",
      r ? (r.ms / 1000).toFixed(1) : "", q.note || "",
    ];
  });
  return "﻿" + [TEST_SCRIPT_COLUMNS, ...rows].map((row) => row.map(csvCell).join(",")).join("\r\n") + "\r\n";
}

// True when no question in this interview has follow-ups: every answer will move
// on whatever it says, so the script can't test follow-ups.
export function noFollowUps(script) {
  return Boolean(script?.questions?.length) && script.questions.every((q) => !q.has_follow_ups);
}
